import { render, staticRenderFns } from "./LabstaffNavigationDrawer.vue?vue&type=template&id=114b32aa"
import script from "./LabstaffNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./LabstaffNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports